export default {
  id: '1d56d7a2cc',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="appPage" style="background-color: #F8F8F8">\n        <div class="page-content appshow" id="appshow"></div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};